import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React__default, { forwardRef } from 'react';
import MaterialButton from '@mui/material/Button';
import c from 'classnames';
import { renderNodeOrComponent } from '../../utils/index.js';
import { PADDING_X, COLOR_CLASSES, TEXT_COLOR_CLASSES, TYPOGRAPHY_CLASSES, getIcons, BUTTON_SIZE_CLASSES, BORDER_RADIUS, ALIGNMENT_CLASSES } from '../utils/utils.js';

var _excluded = ["alignment", "appearance", "children", "classes", "className", "disabled", "endIcon", "EndIcon", "fullWidth", "loading", "onClick", "shape", "size", "startIcon", "StartIcon", "typography", "variant"];
var Button = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$alignment = props.alignment,
    alignment = _props$alignment === void 0 ? 'center' : _props$alignment,
    _props$appearance = props.appearance,
    appearance = _props$appearance === void 0 ? 'primary' : _props$appearance,
    children = props.children,
    classes = props.classes,
    className = props.className,
    disabled = props.disabled,
    endIcon = props.endIcon,
    EndIcon = props.EndIcon,
    fullWidth = props.fullWidth,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    onClick = props.onClick,
    _props$shape = props.shape,
    shape = _props$shape === void 0 ? 'theme' : _props$shape,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    startIcon = props.startIcon,
    StartIcon = props.StartIcon,
    typography = props.typography,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'filled' : _props$variant,
    restProps = _objectWithoutPropertiesLoose(props, _excluded);
  var sizeClasses = BUTTON_SIZE_CLASSES[size];
  var borderRadius = BORDER_RADIUS[shape];
  var paddingX = PADDING_X[size][shape];
  var colorClasses = COLOR_CLASSES[variant][appearance];
  var textColorClasses = (typography == null ? void 0 : typography.color) || TEXT_COLOR_CLASSES[variant][appearance];
  var alignmentClasses = ALIGNMENT_CLASSES[alignment];
  var typographyVariant = (typography == null ? void 0 : typography.variant) || TYPOGRAPHY_CLASSES[size];
  var startIconRendered = renderNodeOrComponent({
    Component: StartIcon,
    node: startIcon,
    props: {
      className: classes == null ? void 0 : classes.icon,
      fillColorToken: classes == null ? void 0 : classes.fillColorToken
    }
  });
  var endIconRendered = renderNodeOrComponent({
    Component: EndIcon,
    node: endIcon,
    props: {
      className: classes == null ? void 0 : classes.icon,
      fillColorToken: classes == null ? void 0 : classes.fillColorToken
    }
  });
  var icons = getIcons({
    appearance: appearance,
    endIcon: endIconRendered,
    loading: loading,
    startIcon: startIconRendered,
    variant: variant
  });
  return /*#__PURE__*/React__default.createElement(MaterialButton, _extends({
    ref: ref,
    className: c('normal-case tracking-normal py-0 inline-flex', sizeClasses, borderRadius, paddingX, colorClasses, textColorClasses, alignmentClasses, typographyVariant, className, typography == null ? void 0 : typography.className),
    classes: classes,
    disabled: disabled || loading,
    endIcon: icons.endIcon,
    fullWidth: fullWidth,
    startIcon: icons.startIcon,
    onClick: onClick
  }, restProps), children);
});

export { Button as default };
//# sourceMappingURL=Button.js.map
